import { render, staticRenderFns } from "./DialogoTransferencias.vue?vue&type=template&id=a4a0eb00&scoped=true&"
import script from "./DialogoTransferencias.vue?vue&type=script&lang=js&"
export * from "./DialogoTransferencias.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4a0eb00",
  null
  
)

export default component.exports